{
  "name": "iobroker.mytime",
  "version": "3.0.5",
  "description": "This adapter handle Time (eg: countdown,etc.)",
  "author": {
    "name": "oweitman",
    "email": "oweitman@gmx.de"
  },
  "homepage": "https://github.com/oweitman/ioBroker.mytime",
  "license": "MIT",
  "keywords": [
    "ioBroker",
    "mytime",
    "timeseries",
    "countdown timer"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/oweitman/ioBroker.mytime.git"
  },
  "engines": {
    "node": ">= 22"
  },
  "dependencies": {
    "@iobroker/adapter-core": "^3.4.3",
    "dayjs": "^1.11.23",
    "rrule": "^2.8.1",
    "suncalc3": "^2.0.5"
  },
  "devDependencies": {
    "@alcalzone/release-script": "^5.2.1",
    "@alcalzone/release-script-plugin-iobroker": "^5.2.0",
    "@alcalzone/release-script-plugin-license": "^5.2.2",
    "@alcalzone/release-script-plugin-manual-review": "^5.2.0",
    "@iobroker/adapter-dev": "^1.5.0",
    "@iobroker/build-tools": "^3.0.1",
    "@iobroker/eslint-config": "^2.3.4",
    "@iobroker/testing": "^5.3.0",
    "@iobroker/types": "^7.1.2",
    "@iobroker/vis-2-widgets-react-dev": "^4.0.4",
    "@tsconfig/node22": "^22.0.6",
    "@types/node": "^22.13.14",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "alcalzone-shared": "^5.0.0",
    "typescript": "~5.9.3"
  },
  "bugs": {
    "url": "https://github.com/oweitman/ioBroker.mytime/issues"
  },
  "main": "main.js",
  "files": [
    "admin/",
    "lib/",
    "widgets/**/!(tsconfig|tsconfig.*|.eslintrc|en).json",
    "widgets/**/*.{html,css,png,svg,jpg,ttf}",
    "widgets/**/dist/*.{js,map}",
    "widgets/**/lib/*.{js,map}",
    "!widgets/node_modules/**",
    "www/",
    "io-package.json",
    "LICENSE",
    "main.js"
  ],
  "scripts": {
    "test:declarations": "tsc -p test/lib/TS/tsconfig.json && tsc -p test/lib/JS/tsconfig.json",
    "test:javascript": "node node_modules/mocha/bin/mocha --exit",
    "test": "npm run test:package",
    "test:package": "mocha test/package --exit",
    "test:integration": "mocha test/integration --exit",
    "build:admin": "node tasks.mjs --default",
    "build:widgets": "cd widgets && npm run build",
    "build": "npm run build:widgets && npm run build:admin",
    "dev:upload": "dev-server upload",
    "dev:run": "dev-server run",
    "dev:watch": "dev-server watch --noStart",
    "prepublishOnly": "npm run build",
    "release": "release-script --all",
    "release:3x": "release-script --all --branch-pattern release3x",
    "release-patch": "release-script patch --yes",
    "release-minor": "release-script minor --yes",
    "release-major": "release-script major --yes",
    "translate": "translate-adapter",
    "update-packages": "ncu --upgrade && cd src && ncu --upgrade && cd ../src-admin && ncu --upgrade",
    "npm": "npm i && cd src-admin && npm i",
    "lint": "eslint -c eslint.config.mjs .",
    "repochecker": "npx @iobroker/repochecker https://github.com/oweitman/ioBroker.mytime --local --noinfo",
    "translate-admin-deletekey": "node ./src-admin/bin/translate.js deletekey 'xx,xx'",
    "translate-admin": "node ./bin/translate.js --source src-admin/src/i18n",
    "translate-widgets": "node ./bin/translate.js --source widgets/mytime/myi18n/en.json --format single"
  },
  "readmeFilename": "README.md"
}
